import { EvidenceItem } from "./Evidence";

export const dataSourceOrderByKeys = [
    "Name",
    "UniqueReference",
    "LocationName",
    "Scope",
] as const;

export type DataSourceOrderBy = (typeof dataSourceOrderByKeys)[number];

export const isDataSourceOrderBy = (
    value: string
): value is DataSourceOrderBy => {
    return dataSourceOrderByKeys.includes(value as DataSourceOrderBy);
};

export type DataSourceSummary = {
    id: number;
    emissionsSourceId: number;
    scope: number;
    name: string;
    uniqueReference: string;
    locationName: string;
    activityMetadataTypeId: number;
    connectionTypeId?: number;
    connectionTypeName?: string;
    connectionTypeChipColorHex?: string;
    rawUnitsSuffix: string;
    rawUnitsSuffixHtml: string;
    rawMaterialName: string;
    rawMaterialId: string;
    currentEmissionsFactor?: number;
    currentCalculationSetAt?: string;
    currentCalculationActiveFrom?: string;
    currentEmissionsFactorConfidenceId? : number;
    currentCalculationConfidenceReason?: string;
    currentConversionFactor: number;
    currentNormalizedUnitsSuffix: string;
    currentNormalizedUnitsSuffixHtml: string;
    isConnected?: boolean;
};

export type DataSourceDetails = DataSourceSummary & {
    evidence: EvidenceItem[];
    currentCalculationSetByDisplayName?: string;
    calculationHistoryCount: number;
};

export type SetDataSourceCalculationDto = {
    emissionsFactor: number;
    activeFrom: string;
    confidenceId: number;
    confidenceReason: string;
    conversionFactor: number;
    normalizedUnitsId: number;
};

export type DataSourceCalculation = {
    id: number;
    emissionsFactor: number;
    activeFrom: string;
    createdAt: string;
    createdByDisplayName: string;
    dataSourceId: number;
    confidenceReason: string;
};

export type ActivityMetadataType = {
    id: number;
    name: string;
};

export type DataSourceConnectionType = {
    id: number;
    name: string;
};

export type AddDataSourceDto = {
    activityMetadataTypeId?: number;
    connectionTypeId?: number;
    rawUnitsId: number;
    rawMaterialId: number;
    emissionsSourceId: number;
};
